/* eslint-disable no-unused-vars */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { _delete, _get, _post, _put } from "../../Services/baseApi";
import { errorHandler, successToast } from "../../Utils/toast";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import {  SETTING_ADD_URL, SETTING_LIST_URL } from "../../Services/endpoints";
import { handleAsyncState } from "../common/helpers";

const initialState = {
  isLoading: false,
  settingsData: {},
  developerSettings: {
    setting:{
      phoneNumbers:[]
    }
  }
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSettingsThunk.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSettingsThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.settingsData = action.payload;
      })
      .addCase(getSettingsThunk.rejected, (state) => {
        state.isLoading = false;
      });

    builder
      .addCase(addSettingsThunk.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addSettingsThunk.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(addSettingsThunk.rejected, (state) => {
        state.isLoading = false;
      });

  },
});

// export const {} = settingsSlice.actions;
// export default settingsSlice.reducer;

// Define the reducer export with persist data
export default persistReducer(
  {
    key: "settings/persist",
    storage,
    whitelist: [],
  },
  settingsSlice.reducer
);

export const getSettingsThunk = createAsyncThunk(
  "settingsSlice/getSettingsThunk",
  async (payload) => {
    try {
      const response = await _get(`${SETTING_LIST_URL}/${payload?.id}`);
      return response?.data?.data;
    } catch (error) {
      // errorHandler(error);
    }
  }
);

export const addSettingsThunk = createAsyncThunk(
  "settingsSlice/addSettingsThunk",
  async (payload) => {
    try {
      const response = await _post(SETTING_ADD_URL, payload);
      payload.handleFun();
      successToast(response?.data?.message);
      return response?.data?.data;
    } catch (error) {
      errorHandler(error);
    }
  }
);


